import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SideBar from '../../../newDashboard/SideBar';
import Header from '../../../newDashboard/Header';
import { FaArrowLeft,FaChartBar } from 'react-icons/fa';
import SummaryCards from './_summary_cards';
import CategoryCharts from './_category_chart';
import CategoryDetails from './_category_details';
import InvoiceTable from './_invoice_table';

const LedgerReports = () => {
  const [showSidebar, setShowSidebar] = useState(true);
  const [reportData, setReportData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      const mockData = {
        categoryA: {
          totalAmount: 16500,
          paid: 7500,
          pending: 9000,
          tenants: 303,
          monthlyData: [5000, 6000, 5500]
        },
        categoryB: {
          totalAmount: 15500,
          paid: 15500,
          pending: 0,
          tenants: 872,
          monthlyData: [7500, 8000]
        },
        overall: {
          totalAmount: 32000,
          paid: 23000,
          pending: 9000,
          tenants: 5
        }
      };
      setReportData(mockData);
      setLoading(false);
    }, 1500);
  }, []);

  const toggleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  const exportToCSV = () => {
    if (!reportData) return;
    
    const headers = ['Category', 'Total Amount', 'Paid Amount', 'Pending Amount', 'Tenant Count'];
    const csvContent = [
      headers.join(','),
      ...Object.entries(reportData).filter(([key]) => key !== 'overall').map(([category, data]) => [
        `Category ${category.slice(-1)}`,
        data.totalAmount,
        data.paid,
        data.pending,
        data.tenants
      ].join(',')),
      ['Overall', reportData.overall.totalAmount, reportData.overall.paid, reportData.overall.pending, reportData.overall.tenants].join(',')
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    
    link.setAttribute('href', url);
    link.setAttribute('download', 'ledger_report.csv');
    link.style.visibility = 'hidden';
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <div className={`reports_dashboard`}>
        <div className="container-fluid">
    
          
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="mt-2">Loading reports...</p>
            </div>
          ) : (
            <>
              <SummaryCards reportData={reportData} exportToCSV={exportToCSV} />
              <CategoryCharts reportData={reportData} />
              {/* <CategoryDetails reportData={reportData} /> */}
              <InvoiceTable/>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default LedgerReports;